<template>
  <div id="video-wrapper"  :class="[{'demo-video-wrapper':componentStyle.mode == 'demo'}]">
    <div class="main-container">
      <div class="video-wrapper" :class="{ 'full-width': isFullWidth }">
        <div class="spinner-wrapper" v-if="!(isPlayerReady && info)">
          <spinner-loader :show-text="false"></spinner-loader>
        </div>
        <div class="row" :class="{'container-demo':componentStyle.mode == 'demo'}">
          <div :class="{ 'col-md-12': isFullWidth&&isVideoHd , 'col-md-8': (isSideNav || isFullWidth&&!isVideoHd) && !canComment ,'col-md-9':canComment}">
            <div class="video-container">
              <uep-player
                v-if="isPlayerReady && cdnReady"
                :url="currentVideo.cryptext"
                :query="query"
                @readyPlayer="readyPlayer"
                @infoDetails="infoDetails"
              ></uep-player>
            </div>
          </div>
          <div :class="{ 'col-md-12': isFullWidth&&isVideoHd, 'col-md-4': (isSideNav || isFullWidth&&!isVideoHd) && !canComment  , 'col-md-3':canComment}  " >
            <div class="info-wrapper" :class="{ 'info-wrapper-simple': !isRM }">
              <div class="info-container" v-if="isPlayerReady && info" :class="{ 'mt-4': isRM }">


                <div class="demo-meta-data" v-if="componentStyle.mode == 'demo'">
                  <div class="metadata-container" :class="{'demo':componentStyle.mode == 'demo'}"  >
                    <div class="info first" v-if="info.date">
                      <div class="icon-date">
                        <i class="icon-demo-calendar demo-icons"></i>
                      </div>
                      {{ info.date }}
                    </div>
                    <div class="info">
                      <i class="icon-demo-view demo-icons" ></i>
                      {{ info.nb_views }}
                    </div>
                  </div>
                  <span class="pumpkin">  {{info.theme.title}}  </span>
                </div>




                <h4 class="title" :class="{'title-demo':componentStyle.mode == 'demo'}">{{ info.title }}</h4>




                <div class="position-relative">
                  <VuePerfectScrollbar class="scroll-area" ref="ps" style="height: 120px">
                    <p class="description">
                      <span id="description"> {{ info.description }}</span>
                    </p>
                  </VuePerfectScrollbar>
                  <div v-if="showMore" class="read-more">
                    <span v-if="descriptionVisible" class="read-more__less" @click="readLess">
                      {{ $t('buttons.see_less') }}</span
                    >
                    <span v-else="descriptionVisible" class="read-more__more" @click="readMore">
                      {{ $t('buttons.see_more') }}</span
                    >
                  </div>
                </div>

                <div class="metadata-container"  v-if="componentStyle.mode == 'default'">
                  <div class="info">
                    <font-awesome-icon class="icon" :icon="['far', 'faCalendar']" />
                    {{ info.date }}
                  </div>
                  <div class="info" v-if="info.duree">
                    <font-awesome-icon class="icon" :icon="['far', 'clock']" />
                    {{ info.duree }}
                  </div>
                  <div class="info">
                    <font-awesome-icon class="icon" :icon="['far', 'eye']" />
                    {{ info.nb_views }}
                  </div>
                </div>

              </div>

              <div class="btns-wrapper" v-if="isPlayerReady && info && componentStyle.mode == 'default'">

                <div class="action_video_button">
                  <button class="btn-embed btn-download" @click="clickDownload()" v-if="currentVideo.downloadable">
                    {{ $t('buttons.download') }}
                  </button>

                  <button class="btn-embed" @click="clickModal">
                    <img
                      height="16"
                      src="data:image/svg+xml;base64,
    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"
                    />
                    {{ $t('buttons.integrate') }}
                  </button>


                </div>

                <div class="canLike" v-if="canLike">
                <b-button
                  size="sm"
                  :class="{liked:videoLiked ,like: !videoLiked}"
                  @click="updateLike(1)"
                >
                 <font-awesome-icon v-if="!videoLiked" :icon="['far', 'thumbs-up']" />
                  <font-awesome-icon  v-if="videoLiked" :icon="['fas', 'thumbs-up']" /> {{ nbLike }}
                </b-button>

                <b-button
                  size="sm"
                  :class="{liked:videoDisLiked ,like: !videoDisLiked}"
                  @click="updateLike(-1)"
                >
                  <font-awesome-icon v-if="!videoDisLiked" :icon="['far', 'thumbs-down']" />
                  <font-awesome-icon  v-if="videoDisLiked" :icon="['fas', 'thumbs-down']" /> {{ nbDisLike}}
                </b-button>
                </div>
                <div class="social-share-wrapper" v-if="componentStyle.header === 'large' || haveSocialMedia" >
                  <social-sharing
                    :url="videoMedia.link_embed"
                    :title="info.title"
                    hashtags="Empreinte"
                    inline-template
                  >
                    <div class="social-media-container">
                      <network network="facebook">
                        <div class="social-icon facebook">
                          <font-awesome-icon :icon="['fab', 'facebook-square']" />
                        </div>
                      </network>
                      <network network="twitter">
                        <div class="social-icon twitter">
                          <font-awesome-icon :icon="['fab', 'twitter-square']" />
                        </div>
                      </network>
                      <network network="linkedin">
                        <div class="social-icon linkedin">
                          <font-awesome-icon :icon="['fab', 'linkedin']" />
                        </div>
                      </network>
                    </div>
                  </social-sharing>
                </div>
              </div>
              <!-- Todo Marouene verif merge-->
              <div class="btns-wrapper" v-if="isPlayerReady && info && (componentStyle.mode !== 'default' && componentStyle.mode !== 'demo')">
                <div class="info">
                  <font-awesome-icon class="icon" :icon="['far', 'faCalendar']" />
                  {{ info.date }}
                </div>
                <div class="info">
                  <font-awesome-icon class="icon" :icon="['far', 'clock']" />
                  {{ info.duree }}
                </div>
                <div class="info">
                  <font-awesome-icon class="icon" :icon="['far', 'eye']" />
                  {{ info.nb_views }}
                </div>
                <button class="btn-embed" @click="clickModal">
                  <img
                    height="16"
                    src="data:image/svg+xml;base64,
    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"
                  />
                  {{ $t('buttons.integrate') }}
                </button>
                <div class="social-share-wrapper" v-if="componentStyle.header === 'large' || haveSocialMedia" >
                  <social-sharing
                    :url="videoMedia.link_embed"
                    :title="info.title"
                    hashtags="Empreinte"
                    inline-template
                  >
                    <div class="social-media-container">
                      <network network="facebook">
                        <div class="social-icon facebook">
                          <font-awesome-icon :icon="['fab', 'facebook-square']" />
                        </div>
                      </network>
                      <network network="twitter">
                        <div class="social-icon twitter">
                          <font-awesome-icon :icon="['fab', 'twitter-square']" />
                        </div>
                      </network>
                      <network network="linkedin">
                        <div class="social-icon linkedin">
                          <font-awesome-icon :icon="['fab', 'linkedin']" />
                        </div>
                      </network>
                      <network network="instagram">
                        <div class="social-icon instagram">
                          <font-awesome-icon :icon="['fab', 'instagram']" />
                        </div>
                      </network>
                    </div>
                  </social-sharing>
                </div>
              </div>



              <div class="btns-wrapper" v-if="isPlayerReady && info && componentStyle.mode == 'demo'" >



                <div class="canLike" v-if="canLike">
                  <!--
                  :class="{liked:videoLiked ,like: !videoLiked}"
                  -->
                  <div
                    @click="updateLike(1)">

                    <i class="icon-demo-like" v-if="!videoLiked"></i>
                    <i class="icon-demo-like_fill" v-if="videoLiked"></i>


                    {{ nbLike }}
                  </div>
                </div>



                <div class="social-share-wrapper" >


                  <div class="social-share" @click="clickModal" >
                    <i class="icon-demo-share"></i>

                  </div>
                  <social-sharing
                    :url="videoMedia.link_embed"
                    :title="info.title"
                    hashtags="Empreinte"
                    inline-template
                  >
                    <div class="social-media-container">
                      <network network="facebook">
                        <div class="social-demo-icon facebook">
                          <i class="icon-demo-Facebook social-demo-icon"></i>
                        </div>
                      </network>
                      <network network="twitter">
                        <div class="social-demo-icon twitter">
                          <i class="icon-demo-Twitter social-demo-icon"></i>

                        </div>
                      </network>
                      <network network="linkedin">
                        <div class="social-demo-icon linkedin">
                          <i class="icon-demo-Linkedin social-demo-icon"></i>
                        </div>
                      </network>
                    </div>
                  </social-sharing>
                </div>
              </div>


            </div>



            </div>

            <modal-export
              ref="exportModal"
              :embedUrl="videoMedia.link_embed"
              :embedUrlPer="videoMedia.link"
              :interactions="interactions"
              :textes="texts"
            >
            </modal-export>
            <div id="share-links" v-html="shareBtns"></div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import ComponentVideo from '~/node_modules/component-video/src/components/Componentplay.vue';
import ModalExport from '~/node_modules/modal-export/src/components/Component.vue';
import SpinnerLoader from './common/SpinnerLoader';
import Mixin from '@/mixins/Mixin';
import { service } from '../service';


export default {
  name: 'mainContent',
  components: {
    ComponentVideo,
    ModalExport,
    VuePerfectScrollbar,
    SpinnerLoader,
  },
  props: {
    // info:'',
    shareBtns: '',
  },
  data() {
    return {
      player: {},
      shareHtml: '',
      info: '',
      interactions: [],
      loading: false,
      check: false,
      fail: false,
      visible: false,
      required: false,
      embedUrlLecture: true,
      OptionInteraction: true,
      showMore: false,
      descriptionVisible: false,
      descriptionTruncate: 200,
      playerSkin: 'dark',
      cdnReady: true,
      tokenUser:'',
      canLike:process.env.LIKE,

    };
  },
  computed: {
    ...mapGetters({
      currentTheme: 'videos/getCurrentTheme',

      currentVideo: 'videos/getCurrentVideo',
      videoMedia: 'videos/getVideoMedia',
      isFullWidth: 'layout/isFullWidth',
      isSideNav: 'layout/isSideNav',
      componentStyle: 'layout/getComponentStyle',
      haveSocialMedia:'layout/getHaveSocialMedia',
      videos: 'videos/getAllVideos',
      currentPlayerSkin: 'layout/getCurrentSkinPlayer',
      videoLiked: 'videos/getVideoLike',
      videoDisLiked: 'videos/getVideoDisLike',
      isVideoHd: 'layout/getIsVideoHd',
      nbLike:'videos/getNbLike',
      nbDisLike:'videos/getNbDisLike',
    }),
    canComment(){
      return process.env.COMMENTS;
    },
    texts() {
      return {
        integrations: this.$t('labels.integrations'),
        integrations_options: this.$t('labels.integrations_options'),
        start_video_auto: this.$t('labels.start_video_auto'),
        default_color: this.$t('labels.default_color'),
        start_at: this.$t('labels.start_at'),
        share_social: this.$t('labels.share_social'),
        copy: this.$t('buttons.copy'),
        downloads: this.$t('labels.downloads'),
        embedTitle: this.$t('labels.embedTitle'),
        permalink: this.$t('labels.permalink'),
      };
    },
    isPlayerReady() {
      return this.currentVideo.cryptext && this.player;
    },
    isRM() {
      return this.isPlayerReady && this.currentVideo.type === 'isRM';
    },
    truncatedDescription() {
      if (!(this.info && this.info.description)) {
        return '';
      }
      return this.descriptionVisible
        ? this.info.description
        : `${this.info.description.substring(0, this.descriptionTruncate)}...`;
    },
    query() {
      let plugin = this.currentVideo.type === 'isInteractivity' ? 'interactivity' : 'navigation';
      return {
        skin: this.currentPlayerSkin ? this.currentPlayerSkin : this.playerSkin,
        plugin: plugin,
        a: false,
        videoStats: false,
        ...this.$route.query,
      };
    },
  },
  watch: {
    currentVideo(video) {
      this.cdnReady = false;
      console.log('video--------',video)
      if(video.nbviews && video.nbviews!==''){
          this.info.nb_views = video.nbviews
      }
      setTimeout(() => {
        this.cdnReady = true;
      }, 100);
    },
  },
  methods: {
    ...mapActions('videos', ['setCurrentVideo', 'getVideoMediaById','updateVotes']),

    readyPlayer(param) {
      var self = this;
      this.player = param;
      this.updateVideoHeight();
      setTimeout(() => {
        this.updateReadMore();
      }, 1000);

      this.info = {
        title : this.currentVideo.title,
        description : this.currentVideo.description,
        nb_views : this.currentVideo.nbviews,
        duree : this.currentVideo.duration,
        date : this.currentVideo.date,
        theme : this.currentVideo.theme
      }
      this.player.on('error', function() {
        if (self.player.options_ && self.player.options_.sources[1]) self.player.src(self.player.options_.sources[1]);
      });

    },
    infoDetails(param) {
      this.$Progress.finish();
     this.info = param;


     /*let tempElement = document.createElement("div");
      tempElement.innerHTML = this.info.description;
        var description = document.getElementById('description')

      setTimeout(()=>{
        if(description)
             description.appendChild(tempElement);
      },100)*/


      this.updateVideoHeight();
      this.updateReadMore();
    },
    clickModal() {
      this.$refs.exportModal.show();
    },

    async clickDownload(){

      const { data } = await service.getVideoDownload(this.currentVideo.id)

      if(data && data.code == 200 && data.data.exist ){
        let link = document.createElement('a');
        link.href = data.data.file;
        link.setAttribute("download",this.currentVideo.title);
        link.click();
      }else{
        console.log("errer download video")
      }



    },
    updateVideoHeight() {
      const videoWrapper = document.querySelector('.video-wrapper.full-width');
      const videoContainer = document.querySelector('.video-container');
      const uepPlayer = document.querySelector('.uep_player_v2');
      const namePlayer = document.querySelector('#name_player');
      //const infoWrapper = document.querySelector('.info-wrapper-simple');
      const flashPlayer = document.querySelector('object.vjs-tech');
      const videoJS = document.querySelector('.video-js');
      const html5Video = document.querySelector('.video-js video.vjs-tech');
      try {
        if (videoWrapper) {
          if(this.isFullWidth && this.isVideoHd)
            videoWrapper.style.minHeight = `${videoWrapper.offsetWidth * (9 / 16)}px`;
          else
            videoWrapper.style.minHeight = `${videoWrapper.offsetWidth * (9 / 24)}px`;
        }
        const height = `${videoContainer.offsetWidth * (9 / 16)}px`;
        uepPlayer.style.height = height;
        namePlayer.style.height = height;
        videoJS.style.minHeight = '100%';
        if (
          (flashPlayer ||
            navigator.userAgent.indexOf('MSIE') !== -1 ||
            navigator.appVersion.indexOf('Trident/') > -1) &&
          !html5Video
        ) {
          flashPlayer.setAttribute('style', `height:${height} !important`);
        }
      } catch (e) {
        // HACK for IE 11
        setTimeout(() => {
          this.updateVideoHeight();
        }, 3000);
      }
      setTimeout(() => {
        this.updateReadMore();
      }, 100);
    },
    updateReadMore() {
      const infoWrapper = document.querySelector('.info-wrapper');
      const videoJS = document.querySelector('.video-container');
      const titleEl = document.querySelector('.info-container .title');
      const descriptionEl = document.querySelector('.info-container .description');
      const metadataEl = document.querySelector('.metadata-container');
      const btnEmbedEl = document.querySelector('.btns-wrapper');

      const videoHeight = videoJS.offsetHeight;
      let descriptionHeight = videoHeight;

      if (titleEl) {
        let { height, marginTop, marginBottom } = window.getComputedStyle(titleEl);
        descriptionHeight -= parseFloat(height) + parseFloat(marginTop) + parseFloat(marginBottom);
      }

      if (metadataEl) {
        descriptionHeight -= metadataEl.offsetHeight;
      }

      if (btnEmbedEl) {
        let { height, marginTop, marginBottom } = window.getComputedStyle(btnEmbedEl);
        descriptionHeight -= parseFloat(height) + parseFloat(marginTop) + parseFloat(marginBottom);
      }

      if (descriptionEl) {
        this.showMore = descriptionEl.offsetHeight > 120;
      }

      if (this.$refs.ps) {
        if (this.showMore) {
          if (this.descriptionVisible) {
            if (this.isSideNav && window.innerWidth > 1200 ) {
              this.$refs.ps.$el.style.height = `${descriptionHeight}px`;
            } else if( window.innerWidth > 446 && window.innerWidth < 1200 ){
              this.$refs.ps.$el.style.height = 'auto';
            }else if( window.innerWidth < 446){
              this.$refs.ps.$el.style.height = `${videoHeight}px`;

            }
            else {
              this.$refs.ps.$el.style.height = '300px';
            }
          } else {
            this.$refs.ps.$el.style.height = '120px';
          }
        } else {
          this.$refs.ps.$el.style.height = 'auto';
        }
      }
      /*
      console.log("window.innerWidth",window.innerWidth)
      if (this.isSideNav && window.innerWidth > '1200px') {
        infoWrapper.style.height = `${videoHeight}px`;
      } else {
        infoWrapper.style.height = 'auto';
      } */

      },
    readMore() {
      this.descriptionVisible = true;
      this.updateReadMore();
      setTimeout(() => {
        this.$refs.ps.update();
      }, 100);
    },
    readLess() {
      this.descriptionVisible = false;
      this.updateReadMore();
      setTimeout(() => {
        this.$refs.ps.update();
      }, 100);
    },
    updateLike(){
      let self=this;
      this.liked = !this.liked;
      var typeVote = this.liked ? 1 :0
      var params = {video:this.currentVideo.id,
      user:this.tokenUser,
      vote:typeVote};
      self.updateVotes(params);
    }
  },
  created() {},
  mixins: [Mixin],
  mounted() {
    this.$nextTick(() => {
      this.updateVideoHeight();
      this.updateReadMore();
      if (!this.currentVideo || Object.keys(this.currentVideo).length === 0) {
        this.setCurrentVideo(this.videos[0]);
        this.getVideoMediaById(this.videos[0].id);
      }
      if(this.$cookies.isKey('tokenUserFo')){
        this.tokenUser=this.$cookies.get('tokenUserFo')

      }else{
        this.tokenUser= this.makeToken();
        this.$cookies.set('tokenUserFo', this.tokenUser);
      }
    });

    window.addEventListener('resize', () => {
      this.updateVideoHeight();
      this.updateReadMore();
    });
    eventHub.$on('skinPlayerUpdated', () => {
      let video = this.currentVideo;
      let cryptext = video.cryptext;
      this.playerSkin = this.currentPlayerSkin;
      video.skin = this.playerSkin;
      video.cryptext = '';
      this.setCurrentVideo(video);
      video.cryptext = cryptext;
      this.setCurrentVideo(video);
    });
  },
};
</script>

<style scoped lang="scss">
@import '../assets/scss/_variables';
@import "../assets/scss/mix.scss";


.action_video_button{
  display: flex;
  justify-content: start;
}
.btn-download{
  margin-right: 0.5em;
}

/*
#video-wrapper .main-container .video-wrapper .info-wrapper .btns-wrapper{
  @media screen and (max-width: 770px) {
    flex-direction: row !important;
    margin-top: 0em !important;
  }
}
*/
:not(.demo-video-wrapper){
  @media screen and (max-width: 1200px) {
    .col-md-3 ,.col-md-9 {
      -webkit-box-flex: 0;
      -ms-flex: 0 0 100%!important;
      flex: 0 0 100%!important;
      max-width: 100%!important;

    }
    .canLike , .btn-embed , .social-share-wrapper{
      margin-top: 1em;

    }
  }
}




#video-wrapper {
  .modal-open {
    overflow: hidden;
  }

  /deep/ {
    .modal-data {
      overflow: hidden !important;
      --modal-export-modal-data-text-align: left;
    }

    .link-data {
      --modal-export-p-text-align: left;
      --modal-export-link-data-align-items: start;
      --modal-export-link-button-margin: 0;
    }
    @media screen and (max-width: 576px) {
      .link-data:not(.auto-play-container):not(.color-container):not(.start-at-container) {
        flex-direction: column !important;
      }
    }
  }

  /deep/ {
    .start-at-container {
      padding-bottom: 10px;
    }

    .link-detail,
    .link-data:not(.auto-play-container):not(.color-container):not(.start-at-container) {
      align-items: start;

      p:not(.link-p) {
        min-width: 110px;
      }

      .link-p,
      .textarea-code,
      .textarea-code-iframe {
        border: 1px solid #e0e0e0 !important;
        margin: 0 10px 10px !important;
        border-radius: 2px;
        padding: 0.375rem 0.75rem;
        line-height: 1.5;
        color: #6a7887;
        flex-grow: 2 !important;
        @media screen and (max-width: 576px) {
          width: var(--modal-export-link-p-width, 100%) !important;
          margin: 5px 0 !important;
        }
      }

      .linkButton {
        margin: 0 !important;
        transition: 0.3s ease-in-out !important;
        min-width: 90px;

        &.is-copied {
          background: #4db6ac !important;
          color: #fff !important;
        }
      }
    }

    .link-container:last-child .link-detail {
      border-bottom: none !important;
    }
  }

  /deep/ .items.links .items.links {
    padding: 0 15px;
  }

  .main-container {
    position: relative;
    .video-wrapper {
      margin: 2em 15px 0;
      min-height: 30vh;
      &.full-width {
        padding: 1em;
        background-color: #eceff1;
        border-radius: 0.1em;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
        .read-more {
          /*background-image: linear-gradient(*/
            /*to top,*/
            /*#ebeef1,*/
            /*rgba(235, 238, 241, 0.9) 50%,*/
            /*transparent*/
          /*) !important;*/
        }
      }
      &.collapsed {
        min-height: 0;
        padding: 0 1em !important;
        margin: 0 15px !important;
        overflow: hidden;
      }

      .info-wrapper {
        display: flex;
        align-items: start;
        justify-content: space-between;
        flex-direction: column;

        .info-container {
          flex-grow: 1;
          display: flex;
          flex-direction: column;

          .title {

            @include hasColorTitre(var(--color-title));
            margin-top: 0.2em;
            margin-bottom: 0.8em;
          }

          .description {
            color: #435765;
            font-size: 0.9em;
            word-break: break-word;
            padding-bottom: 20px;
            span {
              white-space: pre-line;
            }
          }
          .read-more {
            width: 100%;
            /*background-image: linear-gradient(*/
              /*to top,*/
              /*rgb(250, 250, 250),*/
              /*rgba(250, 250, 250, 0.9) 50%,*/
              /*transparent*/
            /*);*/
            z-index: 1;
            font-size: 0.8em;
            color: #8c8c8c;
            text-decoration: underline;
            margin-top: 0;
            bottom: 0;
            padding: 20px 0 0px;
            /* position: absolute; */
            span {
              cursor: pointer;
            }
          }

          .metadata-container {

            @include hasColorTitre(var(--color-title));

            font-size: 0.8em;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-top: 1px solid #c5c6c7;
            padding-top: 0.8em;
            flex-shrink: 0;

            .info {
              display: flex;
              align-items: center;
              .icon {
                font-size: 1.2em;
                margin-right: 0.2em;
              }
            }
          }
        }
        .btns-wrapper {
          width: 100%;
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          -webkit-box-orient: horizontal;
          -webkit-box-direction: normal;
          -ms-flex-direction: row;
          flex-direction: row;
          -ms-flex-wrap: wrap;
          flex-wrap: wrap;
          align-items: center;
          justify-content: space-between;

          /*
          @media (max-width: 1199px) {
            flex-direction: column;
            align-items: start;
          }*/


          .btn-embed {
            border-radius: 2px;
            border: 1px solid #a0a0a0;
            background: #eceff1;
            padding: 3px;
            cursor: pointer;
            width: 160px;
            color: rgba(0, 0, 0, 0.8);
            flex-shrink: 0;
          }
          .liked{
            color: #fff;
            background-color: var(--primary-color);
            border-color: var(--primary-color);
            &:active,&:focus {
              color: #fff;
              background-color: var(--primary-color);
              border-color: var(--primary-color);
              box-shadow:none ;
            }
            &:hover {
              color: var(--primary-color);
              background-color:#fff ;
              border-color: var(--primary-color) ;
              box-shadow:none ;
            }

          }
          .like {
            color: var(--primary-color);
            background-color:#fff ;
            border-color: var(--primary-color) ;
            box-shadow:none ;

            &:active,&:focus {
              color: var(--primary-color);
              background-color:#fff ;
              border-color: var(--primary-color) ;
              box-shadow:none ;
            }
            &:hover {
              color: #fff;
              background-color: var(--primary-color);
              border-color: var(--primary-color);
              box-shadow:none ;
            }
          }
          .social-share-wrapper {
            .social-media-container {
              display: flex;
              align-items: center;
              /deep/ .social-icon {
                font-size: 1.8em;
                margin: 0 0.1em;
                cursor: pointer;
                &.facebook {
                  color: #3b5998;
                }
                &.twitter {
                  color: #55acee;
                }
                &.linkedin {
                  color: #0077b5;
                }
              }
            }
          }
        }
      }

      .video-container {
        width: 100%;
        min-height: 200px;

        /deep/ .component {
          height: initial;
          position: relative;
          width: initial;

          .uep_player {
            height: initial;

            &.isNotRadyPlayer:not(.vjs-tech-flash) {
              display: none;
            }

            .video-player {
              height: initial;

              .video-js:not(.vjs-rich-media-with-slide) {
                height: initial;

                video.vjs-tech {
                  position: relative;
                }

                &.vjs-fullscreen object.vjs-tech {
                  min-height: 100%;
                }
              }

              .video-js {
                .vjs-text-track-display > div > div {
                  width: 90% !important;
                  left: 5% !important;
                  font-size: 17.1px !important;
                }

                &.vjs-rich-media #sliders-container #vjs-sliders-content .vjs-sliders-field {
                  width: calc(((13% - 2em) - 4px) * 1.33) !important;
                }
              }
            }
          }
        }
      }
    }
  }

  /deep/ .modal-data {
    .column-2 {
      height: 32vw;
    }
  }

  /deep/ .start-at-container {
    display: none;
  }

  .spinner-wrapper {
    height: calc(100% - 2em);
    position: absolute;
    width: calc(100% - 4em);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /*
  @media (max-width: 1200px) {
    .main-container .video-wrapper {
      padding: 0.5em;
      margin: 1em 0 0;

      .info-wrapper {
        height: auto !important;

        .info-container {
          margin-top: 2em;
        }
      }
    }
  }*/

  @media (max-width: 980px) {
    /deep/ .modal-data {
      .column-2 {
        height: auto;
      }
    }
  }

  @media only screen and (max-width: 991px) {
    .video-container {
      /deep/ .component {
        .uep_player {
          .video-player {
            .video-js {
              &.skin-dark.vjs-rich-media.vjs-rich-media-with-slide {
                &.vjs-user-inactive {
                  #dark-overlay-buttons,
                  .overlay-btns {
                    display: none;
                  }
                }
                .vjs-tech,
                .vjs-slide-items {
                  height: 100% !important;
                }
                .vjs-big-play-button {
                  top: 50%;
                }
                .vjs-sliders-container {
                  display: none;
                }
                #dark-overlay-buttons {
                  align-items: start;
                  bottom: 3.2em !important;
                }
                .overlay-btns {
                  bottom: 2.2em !important;
                }
                .vjs-control-bar {
                  top: calc(80% - 0.2em);
                }
              }
            }
          }
        }
      }
    }
  }

  @media (min-width: 992px) {
    .col-lg-4 {
      padding-left: 5px;
    }
  }

  /*
   * IE 11 Support
   */

  .info-container {
    width: 100%;
  }

  // Modal
  .video-wrapper /deep/ .modal-overlay {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    -webkit-transition: opacity 0.3s ease;
    transition: opacity 0.3s ease;
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-transform: translate(0, 0);
    transform: translate(0, 0);
    outline: 9999px solid rgba(0, 0, 0, 0.5);

    .modal-data {
      background-color: #fff;
      height: 32vw;
      width: 90vw;
      border-radius: 2px;
      text-align: left;
      position: absolute;
      left: 31%;
      top: 50%;
      margin-left: -26vw;
      margin-top: -33vh;
      overflow: hidden;
      z-index: 99999;
      margin-bottom: 40px;

      .row-1 {
        float: left;
        width: 100%;

        .column-1 {
          float: left;
          width: 63%;
        }

        .column-2 {
          float: left;
          width: 37%;
          padding: 0;
          overflow: auto;

          .items {
            display: inline-block;
            -ms-flex-direction: column;
            flex-direction: column;
            -webkit-box-pack: space-around;
            -ms-flex-pack: space-around;
            justify-content: space-around;
            overflow: hidden;
          }

          .links {
            width: 100%;
          }

          .tab-data {
            overflow: hidden;
            border-bottom: 1px solid #ccc;
            margin-bottom: 20px;

            button {
              background-color: #ffffff;
              float: left;
              border: none;
              outline: none;
              cursor: pointer;
              padding: 14px 16px;
              -webkit-transition: 0.3s;
              transition: 0.3s;

              .active {
                background-color: #ffffff;
              }
            }
          }

          .interactions {
            display: flex;
            flex-wrap: wrap;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 25px;
          }

          .link-data {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: start;
            border-bottom: none;
            margin-bottom: 10px;
          }

          p {
            font-size: 15px;
            font-weight: 300;
            position: relative;
            text-align: left;
            float: none;
            margin: 0;
            padding: 10px 5px;
            line-height: normal;
            color: #404040;
            flex-grow: 1;
          }

          .link-p {
            width: 19vw;
            word-break: break-all;
          }

          .linkButton {
            background-color: #f0f0f0;
            border: none;
            color: #8d8d8d;
            padding: 10px 25px;
            text-align: center;
            text-decoration: none;
            display: inline-block;
            font-size: 13px;
            margin: 4px 2px;
            transition-duration: 0.4s;
            cursor: pointer;
            border-radius: 5px;
          }

          .share-icon {
            width: 20px;
            color: #888;
            margin: 1px;
          }

          .icon-interactions {
            margin: 10px;
            padding: 10px 5px;
            width: 15px;
            height: 15px;
            color: #909090;
            cursor: pointer;
          }
        }
      }

      .row-2 {
        padding: 7px;
        width: 32px;
        height: 32px;
        background-color: white;
        border-radius: 16px;
        box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.3);
        font-size: 5px;
        margin: 10px 20px;

        .fa-times {
          cursor: pointer;
          width: 16px;
          height: 16px;
          padding: 0px;
        }
      }
    }
  }

  @media screen and (min-width: 980px) {
    /deep/ .modal-overlay .modal-data {
      height: 32vw !important;
      margin-top: -33vh !important;
      overflow-x: hidden !important;
      overflow-y: auto !important;
    }
  }

  @media screen and (max-width: 1703px) and (min-width: 980px) {
    /deep/ .modal-overlay .modal-data {
      height: 32vw !important;
      margin-top: -33vh !important;
      overflow-x: hidden !important;
      overflow-y: auto !important;
    }
  }

  @media screen and (max-width: 980px) {
    /deep/ .modal-overlay .modal-data {
      height: auto !important;
      margin-top: -44vh !important;
      overflow-y: auto !important;

      .row-1 {
        .column-2 {
          height: auto !important;
          width: 100% !important;
        }

        .column-1 {
          width: 100% !important;
        }
      }
    }
  }

  @media screen and (max-width: 1200px) and (min-width: 981px) {
    /deep/ .modal-overlay .linkButton {
      width: 100% !important;
    }
    /deep/ .modal-overlay .link-detail,
    /deep/
      .modal-overlay
      .link-data:not(.auto-play-container):not(.color-container):not(.start-at-container) {
      flex-direction: column !important;
      align-items: start !important;
      padding-bottom: 10px !important;

      .link-p,
      .textarea-code-iframe {
        width: 100% !important;
        flex-grow: 1 !important;
        margin: 0 0 8px 0 !important;
      }
    }
  }

  /deep/ input[type='color'] {
    max-width: 100px !important;
  }

  /deep/ .video-js > button.vjs-big-play-button {
    transition: none !important;
    width: 100px !important;
    height: 100px !important;
    margin-left: -50px;
    margin-top: -50px;
  }

  @media all and (-ms-high-contrast: none) {
    /deep/ {
      .video-js > button.vjs-big-play-button {
        transition: none !important;
      }
    }
  }
}
.title{
  text-overflow: ellipsis;
  word-wrap: break-word;
}
/*---------------------------*/




.icon-demo-Twitter , .icon-demo-Facebook , .icon-demo-Linkedin , .social-demo-icon{
  color: #a1a1a1!important;
}

.demo-video-wrapper{

  @media (max-width: 992px) {

     .main-container .video-wrapper {
      margin: 2em 0 0 !important;
    }
  }


  .icon-demo-like{
    color :#444444;
  }

  .title{
    text-transform: uppercase;
    font-size: 26px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
  }

  .info{
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #595959;
  }


  .canLike{
    cursor: pointer;
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #a1a1a1;
  }
  .info-wrapper{
    height: 100%;
  }

  .pumpkin {
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    word-wrap: break-word;
    background-color: var(--secondary-color);
    color: white!important;
    border-radius: 3px;
    width: fit-content;
    padding: 0.3em 0.2em;
    margin-top: 0.8em;
    margin-bottom: 0.6em;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-right: 25px!important;

  }
  .social-share-wrapper{
    display: flex;
  }
  .social-share{
    cursor: pointer;
    padding: 0.5em;
  }


  .metadata-container.demo{
    margin-right: 0.5em;
    margin-bottom: 0.5em!important;

  }



  .metadata-container{
    border-top:none!important;
  }
  .btns-wrapper{
    border-top: 1px solid #c5c6c7;

  }



  @media screen and(max-width: 991px){
    .info-container{
      margin-top: 0!important;
    }
    .demo-meta-data{
      display: flex;
      justify-content: space-between;
      flex-direction: row-reverse;
      .info.first{
        margin-right: 0.5em;
      }
    }
    .container-demo{
      display: flex;
      flex-direction: column;
    }
    .col-md-8 , .col-md-4{
      flex: 0 0 100%!important;
      max-width: 100% !important;
    }
    .pumpkin{
      white-space: nowrap;

    }
  }

}

.demo-icons{
  margin-right: 0.5em;
  font-size: 1.5em;
}

  .darkMode{

    .icon-demo-calendar , .icon-demo-view , .icon-demo-like , .icon-demo-share{
      color :#ffffff;
    }
    .info{
      color: #cacaca;

    }
    .title ,.title-demo{
      color: #ffffff!important;
    }


    #description , .card-text{
      color: #cacaca !important ;
    }
    .pumpkin{
      text-overflow: ellipsis;
      word-wrap: break-word;
      color: white;
    }
    #video-wrapper .main-container .video-wrapper .info-wrapper .info-container {
      .read-more {
        color: #cacaca!important;
      }
    }

  }

@media screen and (max-width: 467px) {
  .title-demo{
    font-size: 18px!important;

  }
}

</style>



// WEBPACK FOOTER //
// src/components/MainContent.vue